import api from '@services/api';
import { PaginationResponse } from '../models/pagination';
import { ChangeSystemStatus, EditSystem, NewSystem, System, SystemRequest } from '../models/system';

/**
 * <p>
 * API endpoints that cover all systems related CRUD calls
 */

export const systemsapi = api.injectEndpoints({
  endpoints: (builder) => ({
    // GET
    systemSearch: builder.query<PaginationResponse<System>, SystemRequest>({
      query: (input: SystemRequest) => ({
        url: encodeURI(
          `/approvers/system/search?bringAll=${input.bringAll}&${
            input.searchTerm ? `searchTerm=${input.searchTerm}&` : ''
          }size=${input.size}&page=${input.page}&sortKey=${input.sortKey}&sortDirection=${input.sortDirection}`,
        ),
        method: 'GET',
      }),
      providesTags: ['System'],
    }),
    addSystem: builder.mutation<void, NewSystem>({
      query: (newSystem) => ({
        url: encodeURI(`/approvers/system/create`),
        method: 'POST',
        body: newSystem,
      }),
      invalidatesTags: ['System'],
    }),
    updateSystem: builder.mutation<void, EditSystem>({
      query: (newSystem) => ({
        url: encodeURI(`/approvers/system/update`),
        method: 'PUT',
        body: newSystem,
      }),
      invalidatesTags: ['System'],
    }),
    changeSystemStatus: builder.mutation<void, ChangeSystemStatus>({
      query: (newStatus) => ({
        url: encodeURI(`/approvers/system/changeStatus`),
        method: 'POST',
        body: newStatus,
      }),
      invalidatesTags: ['System'],
    }),
  }),
});

export const { useSystemSearchQuery, useAddSystemMutation, useUpdateSystemMutation, useChangeSystemStatusMutation } =
  systemsapi;
